<template>
  <section class="c-carousel">
    <div
      id="destinations-carousel"
      class="owl-carousel owl-theme owl-carousel--grayscale"
    >
      <div
        class="item"
        v-for="destination in destinations"
        :key="destination.id"
        :style="{ backgroundImage: `url(${destination.imgUrl})` }"
      >
        <p class="slide-text">
          <span class="slide-title">{{
            getTitle(destination).toUpperCase()
          }}</span
          ><br />
          <span @mouseover="pause" @mouseleave="play">
            <el-button :data-destination="destination.id" type="primary"
              >{{ $t("DESTINATION__CHOOSE_BTN") }}&nbsp;&nbsp;<i
                class="fas fa-plane"
              ></i
            ></el-button>
          </span>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from "vuex"
import "owl.carousel/dist/assets/owl.carousel.css"
import "owl.carousel"
import $ from "jquery"
import { isMobile } from "mobile-device-detect"

import { capitalize } from "../helpers/string"

const { mapState, mapMutations } = createNamespacedHelpers("app")

export default {
  name: "DestinationCarousel",
  computed: {
    ...mapState(["destinations"])
  },
  data() {
    return {
      autoplay: true,
      autoplayDelay: 3000,
      autoplayTimer: null,
      isManualNavigation: false
    }
  },
  methods: {
    ...mapMutations(["setUserDestination", "setSelectedDestination"]),
    initCarousel() {
      const vm = this
      $(document).ready(function() {
        const $carousel = $(".owl-carousel")

        $carousel.owlCarousel({
          items: 1,
          nav: true,
          navText: [
            "<i class='fas fa-angle-left'></i>",
            "<i class='fas fa-angle-right'></i>"
          ],
          loop: true,
          autoplay: vm.autoplay,
          autoplayTimeout: 7000,
          lazyLoad: true,
          responsiveClass: true,
          responsive: {
            // breakpoint from 0 up
            0: {
              stagePadding: 0
            },
            // breakpoint from 480 up
            768: {
              stagePadding: 100
            }
          }
        })

        // Listen for manual navigation events
        $carousel.on("changed.owl.carousel.destinationCarousel", function() {
          vm.$nextTick(() => {
            if (vm.isManualNavigation) {
              const destinationId = $carousel
                .find(".owl-item.active [data-destination]")
                .data("destination")
              const destination = vm.destinations.find(
                d => d.id === destinationId
              )
              // Prevent scroll to the form if the destination is already selected
              vm.setDestination(destination, false)
            }

            // Reset manual navigation flag
            vm.isManualNavigation = false
          })
        })

        const handleManualNavigation = function() {
          vm.isManualNavigation = true
          vm.disableAutoplay()
        }

        $carousel.on(
          "mousedown.destinationCarousel touchstart.destinationCarousel click.destinationCarousel",
          ".owl-nav button, .owl-dots button",
          handleManualNavigation
        )

        $carousel.on(
          "mousedown.destinationCarousel touchstart.destinationCarousel",
          ".owl-stage, [data-destination]",
          function() {
            vm.disableAutoplay()
          }
        )

        // Track manual navigation via drag
        $carousel.on("drag.owl.carousel.destinationCarousel", function() {
          vm.isManualNavigation = true
          vm.disableAutoplay()
        })

        $("[data-destination]").on("click.destinationCarousel", function() {
          const destinationId = $(this).data("destination")
          const destination = vm.destinations.find(d => d.id === destinationId)
          vm.setDestination(destination)
        })
      })
    },
    destroyCarousel() {
      const container = $("#destinations-carousel")
      if (container.hasClass("owl-carousel")) {
        // Remove event listeners
        container.off(".destinationCarousel")

        container.owlCarousel({
          touchDrag: false,
          mouseDrag: false
        })
        container.trigger("destroy.owl.carousel")
        container.removeClass("owl-loaded")
        container
          .find(".owl-stage-outer")
          .children()
          .unwrap()
        container.removeData()
      }
      $("[data-destination]").off(".destinationCarousel")
    },
    pause() {
      const container = $("#destinations-carousel")
      container.trigger("stop.owl.autoplay")
    },
    disableAutoplay() {
      if (this.autoplayTimer) {
        clearTimeout(this.autoplayTimer)
        this.autoplayTimer = null
      }
      if (!this.autoplay) return
      this.autoplay = false
      this.pause()
    },
    play() {
      if (!this.autoplay) return
      const container = $("#destinations-carousel")
      container.trigger("play.owl.autoplay")
    },
    getTitle(destination) {
      return destination[`title${capitalize(this.$i18n.locale)}`]
    },
    setDestination(destination, notifyParent = true) {
      this.setUserDestination(destination.id)
      this.setSelectedDestination(destination)
      this.disableAutoplay()
      if (notifyParent) {
        // Emit an event to notify the parent component
        this.$emit("destinationUpdated", destination)
      }
    }
  },
  created() {
    this.autoplay = !isMobile
  },
  mounted() {
    this.$nextTick(() => {
      this.initCarousel()
      if (this.autoplay) {
        this.pause()
        this.autoplayTimer = setTimeout(() => {
          this.play()
          this.autoplayTimer = null
        }, this.autoplayDelay)
      }
    })
  },
  beforeDestroy() {
    if (this.autoplayTimer) {
      clearTimeout(this.autoplayTimer)
      this.autoplayTimer = null
    }
    this.destroyCarousel()
  }
}
</script>

<style scoped></style>
